const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: 'Usage Status', sortable: true, thStyle: 'width: 10%' },
    { key: 'level', label: 'Level', sortable: false },
    { key: 'type', label: 'Type', sortable: false },
    { key: 'code', label: 'Code', sortable: false },
    { key: 'created_at', label: 'Registed At', sortable: true },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: '사용여부', sortable: true, thStyle: 'width: 10%' },
    { key: 'level', label: '레벨', sortable: false },
    { key: 'type', label: '타입', sortable: false },
    { key: 'code', label: '코드', sortable: false },
    { key: 'created_at', label: '등록일', sortable: true },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
    { key: 'is_alive', label: '利用状況', sortable: true, thStyle: 'width: 10%' },
    { key: 'level', label: 'レベル', sortable: false },
    { key: 'type', label: 'タイプ', sortable: false },
    { key: 'code', label: 'コード', sortable: false },
    { key: 'created_at', label: '登録場所', sortable: true },
  ]
}

const fields = { i18n_fields }

export default fields